// locales文件必须是严格的json数据，最后一个不能有逗号！！
import i18n from "i18next";

// 加载国际化json配置文件
const resources = {};
function importAll(r, lng) {
  r.keys().forEach(key => {
    const name = key.replace(/.\/|.json$/g, "");
    if (resources[lng] === undefined) {
      resources[lng] = {};
    }
    resources[lng][name] = r(key);
  });
}
importAll(require.context("./locales/zh_CN", true, /\.json$/), "zh_CN");
importAll(require.context("./locales/en_US", true, /\.json$/), "en_US");

function i18nInit(lang) {
  try {
    if (typeof window !== "undefined") {
      const backendOpts = {
        loadPath: "./src/locales/{{lng}}/{{ns}}.json",
        addPath: "./src/locales/{{lng}}/{{ns}}.missing.json",
        jsonIndent: 2
      };
      const i18nOpts = {
        lng: lang,
        resources,
        ns: ["common"],
        preload: ["zh_CN", "en_US"],
        defaultNS: "common",
        debug: false,
        backend: backendOpts,
        interpolation: {
          escapeValue: false // not needed for react!!
        }
      };
      i18n.init(i18nOpts);
    }
  } catch (e) {}
}

// 获取当前浏览器语言
const getLang = () => {
  let href = window.location.href;
  if(href.search("lang=")>0){
    if (href.search("lang=en") > 0) {
      return "en";
    } else {
      return "zh";
    }
  }else{
    // 如果连接中没有带语言从缓存中获取语言
    if(window.hwLang === 'en'){
      return "en";
    }else{
      return "zh";
    }
  }

};

const getLoc = (en, cn) => {
  if (getLang() === "en" && en) {
    return en;
  } else {
    return cn;
  }
};

// 设置服务端中英文返回
const setServiMsgbyLang = res => {
  try {
    if (res && typeof res.message === "string" && typeof res.messageEn === "string") {
      let message = this.getLoc(res.messageEn, res.message);
      res.message = message;
    }
    if (res && typeof res.errMsg === "string" && typeof res.errMsgEn === "string") {
      let errMsg = this.getLoc(res.errMsgEn, res.errMsg);
      res.errMsg = errMsg;
    }

    if (res && res.msg && typeof res.msg === "object" && res.msg.message && res.msg.messageEn) {
      let errMsg = this.getLoc(res.msg.messageEn, res.msg.message);
      res.msg.message = errMsg;
    }
  } catch (e) {}
};

i18n.initByLang = i18nInit;
i18n.getLang = getLang;
i18n.getLoc = getLoc;
i18n.setServiMsgbyLang  = setServiMsgbyLang;

export default i18n;
